import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import App from './App';
import { Provider } from 'react-redux';
import store from "./store"
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import theme from './pages/Utils/theme';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
    </Provider>
  </Router>
);
